import axios, { AxiosPromise } from "axios";

export default class LoginService {
  public login(loc = window.location) {
    const port = loc.port ? ':' + loc.port : '';
    loc.href = `//${loc.hostname}${port}/oauth2/authorization/oidc`;
    // loc.href = `http://localhost:8080/oauth2/authorization/oidc`; // for dev
  }

  public logout(): AxiosPromise<any> {
    return axios.post('api/logout');
  }
}
